<div class="widget mail-list-grid">
  <h3 class="title-bar h5">Sent Certified and Standard Mail</h3>
  <a class="homeLink" (click)="goHome()"><span class="fc-icon fc-icon-left-double-arrow vertical-align-middle"></span>&nbsp;&nbsp;Return to Dashboard</a>
  <div class="searchContainer">
    <div class="searchSubContainer">
      <span class="enterCriteria">Enter Search Criteria:</span>
      <span class="searchTitle">Search by Tracking #:</span>
      <div class="trackingNumberContainer">
        <span class="datePickerLabel">Enter Number:</span>
        <input type="text" [(ngModel)]="trackingNumber" placeholder="8888888888888888888888" />
      </div>
    </div>
    <div class="searchSubContainer">
      <span class="searchTitle">Search by Date Range:</span>
      <div class="datePickerContainer">
        <span class="datePickerLabel">Start:</span>
        <common-date-picker [id]="'fromDate'" [initialDate]="fromDate" (dateUpdated)="fromDateChange($event)"></common-date-picker>
      </div>
      <div class="datePickerContainer">
        <span class="datePickerLabel">End:</span>
       <common-date-picker [id]="'toDate'" [initialDate]="toDate" (dateUpdated)="toDateChange($event)"></common-date-picker>
      </div>
    </div>
  </div>
  @if (!canEditStatus) {
    <div class="buttonsContainer">
      <button class="button searchButton" (click)="search()">Search</button>
      <button class="button resetButton" (click)="reset()">Reset</button>
    </div>
  }
  @if (canEditStatus) {
    <div class="buttonsWithSaveContainer">
      <button class="button searchButton" (click)="search()">Search</button>
      <button class="button resetButton" (click)="reset()">Reset</button>
      <button class="button saveStatusChangesButton" (click)="saveLetterChanges()" [disabled]="!hasMailStatusChanged()">Save Status Changes</button>
    </div>
  }
  <tabs (tabClicked)="onTabClicked($event)">
    <tab title="All">
      <div class="cell text-right">
        <button class="button no-margin-bottom" (click)="downloadAllReport()">Download Complete Mail List</button>
      </div>
      <div class="padding-left padding-right">
        <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data" aria-label="All"></ag-grid-angular>
      </div>
    </tab>
    <tab title="Sent">
      <div class="cell text-right">
        <button class="button no-margin-bottom" (click)="downloadSentReport()">Download Sent Mail List</button>
      </div>
      <div class="padding-left padding-right">
        <ag-grid-angular class="data-grid " [gridOptions]="sentGridOptions" [rowData]="sentData" aria-label="Sent"></ag-grid-angular>
      </div>
    </tab>
    <tab title="Returned">
      <div class="cell text-right">
        <button class="button no-margin-bottom" (click)="downloadReturnedReport()">Download Returned Mail List</button>
      </div>
      <div class="padding-left padding-right">
        <ag-grid-angular class="data-grid " [gridOptions]="returnedGridOptions" [rowData]="returnedData" aria-label="Returned"></ag-grid-angular>
      </div>
    </tab>
    <tab title="Delivered">
      <div class="cell text-right">
        <button class="button no-margin-bottom" (click)="downloadDeliveredReport()">Download Delivered Mail List</button>
      </div>
      <div class="padding-left padding-right">
        <ag-grid-angular class="data-grid " [gridOptions]="deliveredGridOptions" [rowData]="deliveredData" aria-label="Delivered"></ag-grid-angular>
      </div>
    </tab>
  </tabs>
</div>
